<template>
    <zm-button size='large' class='opc-succezz__view__account' :type='type' round @click='goToBillingPage'>{{ $t('billing.zuoraoutage.view_my_plan_status') }}
    </zm-button>
  </template>
  <script>
  export default {
    props: {
      type: {
        type: String,
        default: 'primary',
      },
    },
    methods: {
      goToBillingPage() {
        this.$tracking.buyInteraction('purchase confirmation', 'view my plan status');
        window.location.href = '/billing';
      },
    },
  };
  </script>

  <style lang='scss' scoped>
  @import '@zoom/billing-responsive/styles/responsive.scss';
  @import '@/styles/_variables.scss';

  .opc-succezz__view__account {
    &.zm-button--plain:not(.is-ghost) {
      border: 1px solid #0C5CFF;

      .zm-button__slot {
        color: #0C5CFF;
      }
    }
  }

  .opc-modal /deep/ {
    .opc-succezz__view__account {
      &.zm-button.zm-button--large.zm-button--plain.is-round {
        display: block;
        width: auto;
        padding: 8px 24px;
        border-radius: 12px;
        margin: 12px auto 0px;
        line-height: 22px;
      }
    }
  }
  </style>
